import { Box, Modal, Tabs, Tab, Button } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import Tabination from "../../../components/shared/tabs/Tabination";
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { warningModal, handleAddEditModal } from "../../../store/slices/modals";


export default function InvoiceDetails({ tabs, onShow, onHide }) {

    const { handleWarning } = useSelector((state) => {
        return {
            handleWarning: state.modalActions.closeWaringAddProduct,
        }
    });
    const dispatch = useDispatch();
    
    const handleClose = () => {
        // console.log("close");
        dispatch(handleAddEditModal({
            showAddEdit: false
        }));
    };

    return (
        <>
            <Modal
                open={onShow || false}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                keepMounted
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <Box component="div" className="overlay" id="addEditModal">
                    <div className="overlay-box">
                        <div className="content">
                            <div className="overlayBody">
                                <div className="overlay-header text-center"> Invoice Details
                                    <CancelIcon className="closeBtn" onClick={handleClose} />
                                </div>
                                <div className="overlay-content">
                                    {tabs && <Tabination tabs={tabs} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
}
